import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f5acebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "overlay" }
const _hoisted_2 = { class: "load" }

import { ref } from 'vue'

interface Props {
  barColor?: string
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    barColor: { default: 'red' }
  },
  setup(__props: any) {

const props = __props as { barColor: string }

_useCssVars(_ctx => ({
  "528dcbab": (props.barColor)
}))


const bars = ref<number>(5)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bars.value, (i) => {
        return (_openBlock(), _createElementBlock("div", { key: i }))
      }), 128))
    ])
  ]))
}
}

})